// extracted by mini-css-extract-plugin
export default {"compliance_actions_dropdown_button":"dTiFXK4m5LtQLdNiapJFdw=="};